<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="KH năm học + KHGD nhà trường"
          :link="[
            {
              text: 'KH năm học + KHGD nhà trường',
              href: '../schoolSchedule'
            }
          ]"
        />
      </div>
      <div class="flex-center" v-if="isEditDocument">
        <v-btn color="primary" class="elevation-0" @click="upload">
          <span>Upload tệp</span>
          <input ref="uploader" type="file" class="d-none" accept=".pdf, .xlsx, .doc, .docx" @change="onFileChanged" />
        </v-btn>
      </div>
    </div>

    <v-card outlined class="mx-4 elevation-0">
      <SchoolScheduleDataTable ref="table" />
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapActions, mapGetters } from 'vuex'
import SchoolScheduleDataTable from '@/modules/document/SchoolScheduleDataTable.vue'

export default {
  components: {
    Breadcrumbs,
    SchoolScheduleDataTable
  },
  data() {
    return {
      isSelecting: false,
      typeId: '',
      teacher: {},
      documentType: {},
      selecteds: []
    }
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds', 'profile', 'role', 'user', 'isEditDocument'])
  },
  async created() {
    const type = await this.fetchSchoolScheduleDocType()
    this.typeId = type.id
  },
  methods: {
    ...mapActions('Documents', [
      'createDocument',
      'removeDocument',
      'removeDocuments',
      'fetchDocumentType',
      'searchDocuments',
      'requestPageSettings',
      'fetchSchoolScheduleDocType'
    ]),
    ...mapActions('upload', ['uploadFile']),

    upload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      if (this.role.type !== 'teacher') {
        this.$loading.active = true
        const file = e.target.files[0]

        let createdDocument = {}
        try {
          // create document
          const data = {
            documentType: this.typeId,
            createdTeacher: this.profile.id,
            createdUser: this.user.id
          }
          createdDocument = await this.createDocument(data)
          // upload file
          let formData = new FormData()
          formData.append('files', file)
          formData.append('refId', createdDocument.id)
          formData.append('ref', 'document')
          formData.append('field', 'file')

          await this.uploadFile(formData)

          this.$alert.success('Tải file thành công')
          await this.$refs.table.refresh({ documentType: this.typeId })
        } catch (error) {
          this.$alert.error('Tải file thất bại, vui lòng thử lại. Lỗi: ' + error)
          if (createdDocument.id) await this.removeDocument(createdDocument.id)
        } finally {
          this.$loading.active = false
        }
      }
    },
    async search() {
      await this.$refs.table.refresh({ documentType: this.typeId })
    }
    // async removeFiles() {
    //   this.$dialog.confirm({
    //     title: 'Xóa tài liệu',
    //     text: `Bạn có Chắc Chắn muốn xóa ${this.selecteds && this.selecteds.length} tài liệu này không ?`,
    //     okText: 'Có',
    //     cancelText: 'Hủy',
    //     done: async () => {
    //       try {
    //         this.$loading.active = true
    //         await this.removeDocuments(this.selecteds.map(f => f.id))
    //         await this.search()
    //         this.$alert.deleteSuccess()
    //         this.selecteds = []
    //       } catch (error) {
    //         this.$alert.deleteError(error)
    //       } finally {
    //         this.$loading.active = false
    //       }
    //     }
    //   })
    // }
  }
}
</script>
<style scoped></style>
